
import { ResponsivePieCanvas } from '@nivo/pie'
import { ResponsiveBar } from '@nivo/bar'

const TreatmentsByArea = ({ data }) => {

    return (<div className='reportChart' style={ { width: '100%', height: 300, maxHeight: 340 } }>
        <h4>Treatments by Area</h4>
        {data.length > 0 ? <ResponsiveBar
                data={ data.sort(function(a, b) {
                    return b.count - a.count;
                }).slice(0, 7) }
                indexBy="area"
                keys={ [ 'count' ] }
                padding={ 0.4 }
                valueScale={ { type: 'linear' } }
                indexScale={ { type: 'band', round: true } }
                axisTop={ null }
                axisRight={ null }
                role="application"
                margin={ { top: 20, right: 0, bottom: 50, left: 35 } }
                labelSkipWidth={ 12 }
                labelSkipHeight={ 12 }
                labelTextColor="#fff"
                colors={ [
                    '#5c9ceb',
                ] }
            /> : <div className='noData'>No data available</div>}

    </div>)
}


export default TreatmentsByArea;